module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_photowedding_04@2x-3704b3d6ddd5dc6905c7bc848941cd84.webp";